import { useEffect, useState } from "react"
import AppContext from "./AppContext"
import { data } from '../boostrap/config.js'
import { break_line } from '../boostrap/helpers.js'

const AppProvider = ({children}) => {

      const [user, setUser] = useState([])
      const [showFriend, setShowFriend] = useState(false)
      const [showRelation, setShowRelation] = useState(false)
      const [obj, setObj] = useState([])
      const [modal, setModal] = useState(false)

      async function getUser(username){
            const url = `https://xatme.com/api/v2/all/${username}`

            try{
                  const response = await fetch(url)
                  const result = await response.json()
                  setUser(result)
            }
            catch(err){
                  console.log('Error: ' + err);
            }
      }

      useEffect(() => {
            getUser('jason')
      }, [])

      return <AppContext.Provider value={{user, showFriend, showRelation, obj, modal, data, setShowFriend, setShowRelation, setModal, setObj, break_line}}>{children}</AppContext.Provider>
}

export default AppProvider